export default "__VITE_ASSET__t1HmYCRm__"